import { useCallback } from 'react';

import { useAppContext } from '../../../../AppModulesWrapper';
import { EMoneySource } from '../../../types/reducers/user';

import { IUseMoneySourceAnalytics, ITrackMoneySourceClickAnalyticsExtra } from '../types';
import { ANALYTIC_LABEL_BY_MONEY_SOURCE } from '../constants';

export const useMoneySourceAnalytics = (): IUseMoneySourceAnalytics => {
  const { analytics } = useAppContext();

  const trackMoneySourceClick = useCallback(
    (source: EMoneySource) => {
      analytics.send<ITrackMoneySourceClickAnalyticsExtra>({
        action: 'ClickWidget',
        label: ANALYTIC_LABEL_BY_MONEY_SOURCE[source],
        extra: {
          source,
        },
      });
    },
    [analytics],
  );

  return { trackMoneySourceClick };
};
